import type { FC } from 'react';

import { getStaticPrefix } from '@eneco/common/env';
import { Box, Image, Stack, Text } from '@eneco/sparky';

import { creditWarningBox, creditWarningText } from './CreditWarningBar.css';

/**
 * The AFM "borrowing money costs money" credit-warning bar, styled per the legal-mandated look
 * (arial, bold, a plain black border) rather than Sparky's own type/border tokens — the reason this
 * lives in `libs/custom-components` instead of the CMS-agnostic lane directly (`dxp-rules/no-custom-styling`).
 *
 * Carries no content of its own — the legal text and AFM mark are fixed by regulation, not
 * CMS-authored — so it takes no props.
 */
export const CreditWarningBar: FC = () => (
  <Box padding="4" backgroundColor="backgroundPrimary" className={creditWarningBox}>
    <Stack direction="row" alignY="center" alignX="center">
      <Text align="center" size="BodyXL" className={creditWarningText}>
        Let op! Geld lenen kost geld
        <Box as="span" paddingLeft="2">
          <Image
            src={`${getStaticPrefix()}/images/multilabel/afmcreditwarning/afm-beeldmerk.svg`}
            alt=""
            height="28px"
          />
        </Box>
      </Text>
    </Stack>
  </Box>
);

export default CreditWarningBar;
